import { Plus, Trash2 } from "lucide-react";
import { inp, L } from "./inputs";

export const TiersEditor = ({ value, onChange }) => {
  const tiers = value || [];
  const set = (idx, k, v) => onChange(tiers.map((t, i) => (i === idx ? { ...t, [k]: v } : t)));
  const addTier = () => onChange([...tiers, { id: Math.random().toString(36).slice(2, 10), name: "", price: "", capacity: "", sales_start: "", sales_end: "", sold: 0 }]);
  const remove = (idx) => onChange(tiers.filter((_, i) => i !== idx));
  return (
    <div className="space-y-3" data-testid="tiers-editor">
      {tiers.map((t, i) => (
        <div key={t.id || i} className="bg-white/[0.03] border border-white/10 rounded-lg p-3 space-y-2">
          <div className="grid grid-cols-2 gap-2">
            <div><L>Level Name (Early Bird, VIP, Child…)</L><input className={inp} value={t.name || ""} onChange={(e) => set(i, "name", e.target.value)} data-testid={`tier-name-${i}`} /></div>
            <div><L>Price ($ — 0 for free)</L><input type="number" className={inp} value={t.price ?? ""} onChange={(e) => set(i, "price", e.target.value)} data-testid={`tier-price-${i}`} /></div>
            <div><L>Capacity (blank = unlimited)</L><input type="number" className={inp} value={t.capacity ?? ""} onChange={(e) => set(i, "capacity", e.target.value)} /></div>
            <div className="text-xs text-white/40 self-end pb-2">{Number(t.sold || 0)} sold</div>
            <div><L>On Sale From</L><input type="date" className={inp} value={t.sales_start || ""} onChange={(e) => set(i, "sales_start", e.target.value)} /></div>
            <div><L>On Sale Until</L><input type="date" className={inp} value={t.sales_end || ""} onChange={(e) => set(i, "sales_end", e.target.value)} /></div>
          </div>
          <button onClick={() => remove(i)} className="text-xs text-[#E63946] inline-flex items-center gap-1 hover:underline"><Trash2 size={12} /> Remove level</button>
        </div>
      ))}
      <button onClick={addTier} data-testid="add-tier-btn" className="inline-flex items-center gap-2 rounded-full border border-white/15 px-4 py-2 text-xs hover:bg-white/5"><Plus size={13} /> Add Ticket Level</button>
      <p className="text-xs text-white/30">Use levels for Early Bird / Regular / Last-Minute / VIP / Child / Senior / Member / Group pricing. Set sale windows so prices switch automatically.</p>
    </div>
  );
};
